import { useState } from 'react';
import dayjs from 'dayjs';

const ULTIMOS_DIAS = 30;

const initGraph = {
  labels: [],
  datasets: [],
};

export const useSolicitudCoberturaIniciadoAutorizadoBarraApilada = ({
  mensualList,
  anualList,
  anualDate,
  mensualDate,
}) => {
  const [datosAnualesBarrasApiladas, setDatosAnualesBarrasApiladas] = useState(initGraph);
  const [datosMensualesBarrasApiladas, setDatosMensualesBarrasApiladas] = useState(initGraph);

  const getDatosAnualesBarrasApiladas = () => {
    const currentYear = dayjs(anualDate).year();
    const labels = Array.from({ length: 12 }, (_, i) => {
      const fecha = dayjs().year(currentYear).month(i);
      return {
        month: fecha.format('MMM'),
        date: fecha.format('YYYY-MM'),
      };
    });
    const dataValuesPendientes = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');
      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.cantidad_pendientes, 0);
    });
    const dataValuesAutorizados = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');
      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.cantidad_autorizados, 0);
    });

    setDatosAnualesBarrasApiladas(
      prepareGraphData(
        labels.map((l) => l.month),
        dataValuesPendientes,
        dataValuesAutorizados,
      ),
    );
  };

  const getDatosMensualesBarrasApiladas = () => {
    const currentDate = dayjs(mensualDate);
    const startOffset = 0;
    const labels = Array.from({ length: ULTIMOS_DIAS }, (_, i) => {
      const data = currentDate.add(startOffset + i, 'day');
      const result = {
        day: data.format('DD-MM'),
        date: data.format('YYYY-MM-DD'),
      };
      return result;
    });

    const dataValuesPendientes = labels.map((dia) => {
      const fechaLabel = dayjs(dia.date, 'YYYY-MM-DD');
      return mensualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM-DD');
          return fechaItem.isSame(fechaLabel, 'day');
        })
        .reduce((acc, item) => acc + item.cantidad_pendientes, 0);
    });
    const dataValuesAutorizados = labels.map((dia) => {
      const fechaLabel = dayjs(dia.date, 'YYYY-MM-DD');
      return mensualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM-DD');
          return fechaItem.isSame(fechaLabel, 'day');
        })
        .reduce((acc, item) => acc + item.cantidad_autorizados, 0);
    });

    setDatosMensualesBarrasApiladas(
      prepareGraphData(
        labels.map((l) => l.day),
        dataValuesPendientes,
        dataValuesAutorizados,
      ),
    );
  };

  const prepareGraphData = (labels, dataValuesPendientes, dataValuesAutorizados) => {
    return {
      labels,
      datasets: [
        {
          label: 'Pendientes',
          data: dataValuesPendientes,
          backgroundColor: 'rgba(244, 139, 54, 0.9)',
        },
        {
          label: 'Autorizadas',
          data: dataValuesAutorizados,
          backgroundColor: 'rgba(53, 223, 235, 0.9)',
        },
      ],
    };
  };

  return {
    datosAnualesBarrasApiladas,
    datosMensualesBarrasApiladas,
    getDatosAnualesBarrasApiladas,
    getDatosMensualesBarrasApiladas,
  };
};
